// Analyses search routes
export default [
  {
    path: 'change-log',
    name: 'changeLog',
    component: () =>
      import(
        /* webpackChunkName: "changeLog" */ '../views/changeLog/ChangeLog.vue'
      ),
    meta: {
      tabbable: true,
      tableKeys: [],
      filterKeys: [],
      formKeys: ['changeLog'],
      routePermissions: ['changelogView'],
    },
  },
];
